<template>
    <!--Fees and policies-->
    <div class="admin-policy" v-if="user && user.role === 'stylist'">
        <div class="policy-outter-wrapper">
            <div class="fees-and-policies">
                <h3 class="fees-title">Fees & Policies</h3>
            </div>
            <div v-if="!loadingPolicy" class="section-wrap policy-outter-wrapper">
                <!--Deposits Section-->
                <div v-if="user" class="policy-main-container" id="deposits">
                    <!--Deposits content -->
                    <div class="policy-settings-wrap section-wrap">
                        <!--Deposits Header-->
                        <div class="header-container">
                            <h4>{{ $t("policy.deposits") }}</h4>
                            <div class="header-paragraph">
                                <p>
                                    {{ $t("policy.depositRule") }}
                                </p>
                                <p>{{ $t("policy.clients") }}</p>
                            </div>
                        </div>
                        <div class="section-wrap highlighted-box">
                            <div class="policy-checkbox">
                                <h5>{{ $t("policy.deposits") }}</h5>
                                <div>
                                    <label class="switch">
                                        <input type="checkbox" v-model="policy.deposit" />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div v-if="policy.deposit" class="policy-inputs-wrap section-wrap">
                                <div class="policy-input">
                                    <input v-model="policy.deposit_type" type="radio" name="deposit_type"
                                        id="deposit_type_percentage" value="percentage" class="input-width" />
                                    <select v-model="deposit_percentage" name="deposit_fee"
                                        class="deposit-fee-input selectInput selectInputSmall">
                                        <option v-for="i in percentageDropdown" :key="`item-${i}`" :value="i">
                                            {{ i }}%
                                        </option>
                                    </select>
                                    <span>{{ $t("policy.nonRefundableDeposit") }}</span>
                                </div>
                                <div class="policy-input">
                                    <input v-model="policy.deposit_type" type="radio" name="deposit_type"
                                        id="deposit_type_fixed" value="fixed" class="input-width" />
                                    <input type="number" v-model="deposit_fixed" name="deposit_fee"
                                        class="deposit-fee-input text-field text-field-small" />
                                    <span>{{ $t("policy.nonRefundableDeposit") }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="policy.deposit" class="section-wrap highlighted-box">
                            <h5>{{ $t("policy.depositPolicy") }}</h5>
                            <div class="textarea-wrap">
                                <textarea v-model="policy.deposit_policy" class="policy-textarea text-field"
                                    maxlength="4000" placeholder="Write deposit policy"></textarea>
                                <div class="length-limit-label">{{ policy.deposit_policy.length }}/4000</div>
                            </div>
                        </div>
                        <div class="save-policy">
                            <button v-on:click="saveStylistPolicy()" class="primary-btn extra-small mobile">
                                {{ $t("policy.save") }}
                            </button>
                        </div>
                    </div>
                </div>
                <!--Cancellation No Show Section-->
                <div v-if="user" class="policy-main-container" id="cancellation">
                    <div class="policy-settings-wrap section-wrap">
                        <div class="header-container">
                            <h4>{{ $t("adminMenu.cancellationNoshow") }}</h4>
                            <div class="header-paragraph">
                                <p>{{ $t("policy.cancelationRules") }}</p>
                            </div>
                        </div>
                        <div class="section-wrap highlighted-box">
                            <div class="policy-checkbox">
                                <h5>{{ $t("adminMenu.cancellationNoshow") }}</h5>
                                <div>
                                    <label class="switch">
                                        <input type="checkbox" v-model="policy.cancel" />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="policy-inner-wrap">
                                <div v-if="policy.cancel" class="policy-inputs-wrap section-wrap">
                                    <div class="policy-no-show-input">
                                        <span>{{ $t("policy.clientCanCancel") }}</span>
                                        <select v-model="policy.cancel_advance_hours" name="cancel_advance_hours"
                                            class="deposit-fee-input selectInput selectInputSmall">
                                            <option :value="12">12</option>
                                            <option :value="24">24</option>
                                            <option :value="48">48</option>
                                        </select>
                                        <span>{{ $t("policy.hoursInAdvance") }}</span>
                                    </div>
                                </div>
                                <div v-if="policy.cancel" class="policy-inputs-wrap section-wrap">
                                    <h5>{{ $t("policy.fees") }}</h5>
                                    <div class="policy-no-show-input">
                                        <select v-model="policy.cancel_fee" name="cancel_fee"
                                            class="deposit-fee-input selectInput selectInputSmall">
                                            <option v-for="i in percentageDropdown" :key="`item-${i}`" :value="i">
                                                {{ i }}%
                                            </option>
                                        </select>
                                        <span>{{ $t("policy.cancelAfter") }} {{ policy.cancel_advance_hours }}
                                            {{ $t("policy.hours") }}</span>
                                    </div>
                                    <div class="policy-no-show-input">
                                        <select v-model="policy.noshow_fee" name="noshow_fee"
                                            class="deposit-fee-input selectInput selectInputSmall">
                                            <option v-for="i in percentageDropdown" :key="`item-${i}`" :value="i">
                                                {{ i }}%
                                            </option>
                                        </select>
                                        <span>{{ $t("policy.noShow") }}</span>
                                    </div>
                                </div>
                                <div v-if="policy.cancel" class="section-wrap">
                                    <h5>{{ $t("policy.cancellationPolicy") }}</h5>
                                    <div class="textarea-wrap">
                                        <textarea v-model="policy.cancel_policy" class="policy-textarea text-field"
                                            placeholder="Write cancellation policy" maxlength="4000"></textarea>
                                        <div class="length-limit-label">{{ policy.cancel_policy.length }}/4000</div>
                                    </div>
                                </div>
                                <div v-if="policy.cancel" class="section-wrap policy-textarea-wrap" id="being-late">
                                    <div class="policy-checkbox">
                                        <h5>{{ $t("policy.beingLate") }}</h5>
                                    </div>
                                    <div class="policy-being-late-wrap">
                                        <label class="switch">
                                            <input type="checkbox" v-model="policy.being_late" />
                                            <span class="slider round"></span>
                                        </label>
                                        <div class="policy-late-inputs">
                                            <div class="policy-late">
                                                <span class="item-label">{{ $t("policy.late") }}</span>
                                                <input v-model="policy.late_minutes" type="number" name="late_minutes"
                                                    class="fee-input text-field text-field-small" />
                                                {{ $t("policy.min$") }}
                                                <input v-model="policy.late_fee" type="number" name="late_fee"
                                                    class="fee-input text-field text-field-small" />
                                                {{ $t("policy.lateFee") }}
                                            </div>
                                            <div class="policy-late">
                                                <span class="item-label">{{ $t("policy.after") }}</span>

                                                <input v-model="policy.late_minutes_cancel" type="number"
                                                    name="late_minutes_cancel"
                                                    class="fee-input text-field text-field-small" />
                                                {{ $t("policy.minCancelledNoExeptions") }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="save-policy">
                            <button v-on:click="saveStylistPolicy()" class="primary-btn extra-small mobile">
                                {{ $t("policy.save") }}
                            </button>
                        </div>
                    </div>
                </div>
                <!--Reschedule Section-->
                <div v-if="user" class="policy-main-container" id="reschedule">
                    <div class="policy-settings-wrap section-wrap">
                        <div class="header-container">
                            <h4>{{ $t("adminMenu.reschedule") }}</h4>
                            <div class="header-paragraph">
                                <p>{{ $t("policy.rescheduleRules") }}</p>
                            </div>
                        </div>
                        <div class="section-wrap highlighted-box">
                            <div class="policy-checkbox">
                                <h5>{{ $t("adminMenu.reschedule") }}</h5>
                                <div>
                                    <label class="switch">
                                        <input type="checkbox" v-model="policy.reschedule" />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="policy-inner-wrap">
                                <div v-if="policy.reschedule" class="policy-inputs-wrap highlighted-box section-wrap">
                                    <div class="policy-no-show-input">
                                        <span>{{ $t("policy.clientCanReschedule") }}</span>
                                        <select v-model="policy.reschedule_advance_hours"
                                            name="reschedule_advance_hours"
                                            class="deposit-fee-input selectInput selectInputSmall">
                                            <option :value="12">12</option>
                                            <option :value="24">24</option>
                                            <option :value="48">48</option>
                                        </select>
                                        <span>{{ $t("policy.hoursInAdvance") }}</span>
                                    </div>
                                </div>
                                <div v-if="policy.reschedule" class="policy-inputs-wrap highlighted-box section-wrap">
                                    <h5>{{ $t("policy.fees") }}</h5>
                                    <div class="policy-no-show-input">
                                        <select v-model="policy.reschedule_fee" name="reschedule_fee"
                                            class="deposit-fee-input selectInput selectInputSmall">
                                            <option v-for="i in percentageDropdown" :key="`item-${i}`" :value="i">
                                                {{ i }}%
                                            </option>
                                        </select>
                                        <span>{{ $t("policy.rescheduleAfter") }}
                                            {{ policy.reschedule_advance_hours }}
                                            {{ $t("policy.hours") }}</span>
                                    </div>
                                </div>
                                <div v-if="policy.reschedule" class="section-wrap highlighted-box">
                                    <h5>{{ $t("policy.reschedulePolicy") }}</h5>
                                    <div class="textarea-wrap">
                                        <textarea v-model="policy.reschedule_policy" class="policy-textarea text-field"
                                            placeholder="Write reschedule policy" maxlength="4000"></textarea>
                                        <div class="length-limit-label">
                                            {{ policy.reschedule_policy ? policy.reschedule_policy.length : 0 }}/4000
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="save-policy">
                            <button v-on:click="saveStylistPolicy()" class="primary-btn extra-small mobile">
                                {{ $t("policy.save") }}
                            </button>
                        </div>
                    </div>
                </div>
                <!--Age Limit Section-->
                <div v-if="user" class="policy-main-container">
                    <div class="policy-settings-wrap section-wrap">
                        <div class="header-container">
                            <h4>{{ $t("adminMenu.ageLimit") }}</h4>
                        </div>
                        <div class="section-wrap highlighted-box">
                            <div class="policy-age-input">
                                <span class="item-label">{{ $t("policy.onlyAges") }}</span>
                                <input v-model="policy.age_limit" type="number" name="age_limit"
                                    class="fee-input text-field" />
                                {{ $t("policy.andUpOnlyAreAllowed") }}
                            </div>
                        </div>
                        <div class="save-policy">
                            <button v-on:click="saveStylistPolicy()" class="primary-btn extra-small mobile">
                                {{ $t("policy.save") }}
                            </button>
                        </div>
                    </div>
                </div>
                <!--Policy Summary Section-->
                <div v-if="user" class="policy-main-container">
                    <div class="policy-settings-wrap section-wrap">
                        <div class="header-container">
                            <h3>{{ $t("adminMenu.policySummary") }}</h3>
                            <div class="header-paragraph">
                                <p>{{ $t("policy.thisIsASummary") }}</p>
                            </div>
                        </div>
                        <!--Deposits Summary-->
                        <div v-if="!policy.deposit && !policy.cancel && !policy.reschedule"
                            class="section-wrap highlighted-box">
                            <h5>{{ $t("policy.isEnable") }}</h5>
                        </div>
                        <div class="section-wrap highlighted-box" v-if="policy.deposit">
                            <div class="policy-checkbox">
                                <h5>{{ $t("adminMenu.deposits") }}</h5>
                                <div>
                                    <span @click="scrollToMethod('#deposits')"
                                        class="edit-link primary-btn extra-small mobile">{{ $t("policy.edit") }}</span>
                                </div>
                            </div>
                            <div v-if="policy.deposit" class="policy-summary-wrap">
                                <p>
                                    {{ policy.deposit_fee }}<span v-if="policy.deposit_type == 'percentage'">%</span>
                                    {{ $t("policy.nonRefundableDeposit") }}
                                </p>
                                <div v-if="policy.deposit_policy" class="policy-wrap">
                                    <p>{{ $t("policy.policy") }}</p>
                                    <p class="section-wrap policy-summ">
                                        <text-toggle :text="policy.deposit_policy" stringLimit="250"></text-toggle>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--Cancellation Summary-->
                        <div class="section-wrap highlighted-box" v-if="policy.cancel">
                            <div class="policy-checkbox">
                                <h5>{{ $t("adminMenu.cancellation") }}</h5>
                                <div>
                                    <span @click="scrollToMethod('#cancellation')"
                                        class="edit-link primary-btn extra-small mobile">{{ $t("policy.edit") }}</span>
                                </div>
                            </div>
                            <div v-if="policy.cancel" class="policy-summary-wrap">
                                <p>
                                    {{ $t("policy.canCancel") }} {{ policy.cancel_advance_hours }}
                                    {{ $t("policy.hoursInAdvance") }}
                                </p>
                                <p>
                                    {{ policy.cancel_fee }}% {{ $t("policy.feesAfter") }}
                                    {{ policy.cancel_advance_hours }}
                                    {{ $t("policy.hours") }}
                                </p>
                                <p>{{ policy.noshow_fee }}% {{ $t("policy.feesForNoShow") }}</p>
                                <div v-if="policy.cancel_policy" class="policy-wrap">
                                    <p>{{ $t("policy.policy") }}</p>
                                    <p class="section-wrap">
                                        <text-toggle :text="policy.cancel_policy" stringLimit="250"></text-toggle>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--Reschedule-->
                        <div class="section-wrap highlighted-box" v-if="policy.reschedule">
                            <div class="policy-checkbox">
                                <h5>{{ $t("policy.reschedule") }}</h5>
                                <div>
                                    <span @click="scrollToMethod('#reschedule')"
                                        class="edit-link primary-btn extra-small mobile">{{ $t("policy.edit") }}</span>
                                </div>
                            </div>
                            <div class="policy-summary-wrap">
                                <p>
                                    {{ $t("policy.clientCanReschedule") }} {{ policy.reschedule_advance_hours }}
                                    {{ $t("policy.hoursInAdvance") }}
                                </p>
                                <p>After that is a {{ policy.reschedule_fee }}% charge</p>
                                <div v-if="policy.reschedule_policy" class="policy-wrap">
                                    <p>{{ $t("policy.policy") }}</p>
                                    <p class="section-wrap">
                                        <text-toggle :text="policy.reschedule_policy" stringLimit="250"></text-toggle>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--Being Late-->
                        <div class="section-wrap highlighted-box" v-if="policy.cancel && policy.being_late">
                            <div class="policy-checkbox">
                                <h5>{{ $t("policy.beingLate") }}</h5>
                                <div>
                                    <span @click="scrollToMethod('#being-late')"
                                        class="edit-link primary-btn extra-small mobile">{{ $t("policy.edit") }}</span>
                                </div>
                            </div>
                            <div v-if="policy.cancel" class="policy-summary-wrap">
                                <p v-if="policy.being_late">
                                    {{ $t("policy.late") }} {{ policy.late_minutes }} min ${{ policy.late_fee }}
                                    {{ $t("policy.lateFee") }}, {{ $t("policy.after") }}
                                    {{ policy.late_minutes_cancel }}
                                    {{ $t("policy.minCancelledNoExeptions") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MainLoader v-if="loadingPolicy" class="section-wrap" />
        </div>
    </div>
</template>

<script>
import "bootstrap";
import api from "../../services/apiEndpoints.js";
import auth from "../../services/auth.js";
import eventBus from "../../services/eventBus.js";
import messages from "../../services/messages.js";
import TextToggle from "./TextToggle.vue";
import MainLoader from "./general-components/MainLoader.vue";


const INITIAL_POLICY = {
    deposit: false,
    deposit_type: "",
    deposit_fee: 0,
    deposit_policy: "",

    cancel: false,
    cancel_advance_hours: 0,
    cancel_fee: 0,
    noshow_fee: 0,
    cancel_policy: "",

    being_late: false,
    late_minutes: 0,
    late_minutes_cancel: 0,
    late_fee: 0,

    type: "",
    age_limit: 0,

    reschedule: false,
    reschedule_advance_hours: 0,
    reschedule_fee: 0,
    reschedule_policy: "",
};


export default {
    name: "PolicyPage",
    props: ["sections"],
    data: function () {
        return {
            user: null,
            message: "",
            policy: {
                deposit: false,
                deposit_type: "",
                deposit_fee: 0,
                deposit_policy: "",
                cancel: false,
                cancel_advance_hours: 0,
                cancel_fee: 0,
                noshow_fee: 0,
                cancel_policy: "",
                being_late: false,
                late_minutes: 0,
                late_minutes_cancel: 0,
                late_fee: 0,
                type: "",
                age_limit: 0,
                reschedule: false,
                reschedule_advance_hours: 0,
                reschedule_fee: 0,
                reschedule_policy: "",
            },
            percentageDropdown: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
            deposit_percentage: 0,
            deposit_fixed: 0,
            loaded: false,
            loading: false,

            policy: { ...INITIAL_POLICY },
            loadingPolicy: true,
        };
    },
    watch: {
        "policy.cancel"(newVal) {
            if (!newVal) {
                this.policy.cancel_advance_hours = INITIAL_POLICY.cancel_advance_hours;
                this.policy.cancel_fee = INITIAL_POLICY.cancel_fee;
                this.policy.noshow_fee = INITIAL_POLICY.noshow_fee;
                this.policy.cancel_policy = INITIAL_POLICY.cancel_policy;

                // Also reset being late
                this.policy.being_late = false;
            } else {
                this.policy.cancel_advance_hours = 12;
                this.policy.cancel_fee = this.percentageDropdown[0];
                this.policy.noshow_fee = this.percentageDropdown[0];
            }
        },

        "policy.being_late"(newVal) {
            if (!newVal) {
                this.policy.late_minutes = INITIAL_POLICY.late_minutes;
                this.policy.late_fee = INITIAL_POLICY.late_fee;
                this.policy.late_minutes_cancel = INITIAL_POLICY.late_minutes_cancel;
            }
        },

        "policy.deposit"(newVal) {
            if (!newVal) {
                this.policy.deposit_type = INITIAL_POLICY.deposit_type;
                this.policy.deposit_fee = INITIAL_POLICY.deposit_fee;
                this.policy.deposit_policy = INITIAL_POLICY.deposit_policy;
                this.deposit_fixed = 0;
                this.deposit_percentage = 0;
            } else {
                this.policy.deposit_type = "percentage";

            }
        },

        "policy.reschedule"(newVal) {
            if (!newVal) {
                this.policy.reschedule_advance_hours = INITIAL_POLICY.reschedule_advance_hours;
                this.policy.reschedule_fee = INITIAL_POLICY.reschedule_fee;
                this.policy.reschedule_policy = INITIAL_POLICY.reschedule_policy;
            } else {
                this.policy.reschedule_advance_hours = 12;
                this.policy.reschedule_fee = this.percentageDropdown[0];
            }


        },

        "policy.deposit_type"(newVal) {
            if (newVal === "percentage") {
                // set deposit_percentage to the first value in the dropdown
                this.deposit_percentage = this.percentageDropdown[0];
            }
        },


    },

    mounted: function () {
        this.user = auth.state.user;
        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });

        eventBus.on("user_profile_loaded", function () {
            self.user = auth.state.user;
        });
    },
    beforeUnmount() {
        eventBus.off("admin_details_loaded");
        eventBus.off("user_profile_loaded");
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        stylistPolicy: {
            get: function () {
                return this.$store.state.stylistPolicy;
            },
            set: function (value) {
                this.$store.commit("setStylistPolicy", value);
            },
        },
    },
    methods: {
        scrollToMethod(id) {
            const targetElement = document.querySelector(id);

            if (targetElement) {
                const scrollPosition = targetElement.offsetTop - window.innerHeight / 2;
                window.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth",
                });
            }
        },

        onAdminDetailsLoad: function () {
            this.getStylistPolicy();
        },

        getStylistPolicy() {
            this.loaded = false;
            this.loadingPolicy = true;

            this.$http.get(api.actions.get_stylist_policy)
                .then((response) => {
                    this.loaded = true;

                    if (!response.data.error) {
                        const backendPolicy = response.data?.policy || {};

                        for (let key in this.policy) {
                            if (backendPolicy[key] !== undefined) {
                                this.policy[key] = backendPolicy[key];
                            }
                        }

                        this.policy.deposit = backendPolicy.deposit == 1;
                        this.policy.cancel = backendPolicy.cancel == 1;
                        this.policy.being_late = backendPolicy.being_late == 1;
                        this.policy.reschedule = backendPolicy.reschedule == 1;

                        if (this.policy.deposit && !this.policy.deposit_type) {
                            this.policy.deposit_type = "percentage";
                        }

                        if (this.policy.deposit_type === "fixed") {
                            this.deposit_fixed = this.policy.deposit_fee || 0;
                        } else {
                            this.deposit_percentage = this.policy.deposit_fee || 0;
                        }

                        this.stylistPolicy = backendPolicy;
                    }
                })
                .catch((err) => {
                    console.error("Error loading policy:", err);
                })
                .finally(() => {
                    // ✅ Only stop loader once request is done
                    this.loadingPolicy = false;
                });
        },

        saveStylistPolicy() {
            // Step 1: Validate
            const validatedPolicy = this.validatePolicyBeforeSave();

            // Step 2: Convert booleans → 0/1
            const payload = {
                ...validatedPolicy,
                deposit: validatedPolicy.deposit ? 1 : 0,
                cancel: validatedPolicy.cancel ? 1 : 0,
                being_late: validatedPolicy.being_late ? 1 : 0,
                reschedule: validatedPolicy.reschedule ? 1 : 0,
            };

            this.$http.post(api.actions.save_stylist_policy, payload).then((response) => {
                if (response.data.error) return;

                messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                this.getStylistPolicy();
                eventBus.emit("reload_user_details");
            });
        },

        validatePolicyBeforeSave() {

            const cleaned = { ...this.policy };

            // Deposit
            const depositFee =
                cleaned.deposit_type === "fixed"
                    ? this.deposit_fixed
                    : this.deposit_percentage;

            if (cleaned.deposit) {
                const hasConfig =
                    cleaned.deposit_type &&
                    depositFee > 0;

                if (!hasConfig) {
                    cleaned.deposit = false;
                }
            }

            cleaned.deposit_fee = depositFee;

            // Cancel
            if (cleaned.cancel) {

                const hasConfig =
                    cleaned.cancel_advance_hours > 0 ||
                    cleaned.cancel_fee > 0 ||
                    cleaned.noshow_fee > 0;

                // If only description → disable
                if (!hasConfig) {
                    cleaned.cancel = false;
                    cleaned.being_late = false;
                }
            }

            // Being Late
            if (cleaned.being_late) {

                const hasConfig =
                    cleaned.late_minutes > 0 ||
                    cleaned.late_fee > 0 ||
                    cleaned.late_minutes_cancel > 0;

                if (!hasConfig) {
                    cleaned.being_late = false;
                }
            }

            // Reschedule
            if (cleaned.reschedule) {

                const hasConfig =
                    cleaned.reschedule_advance_hours > 0 ||
                    cleaned.reschedule_fee > 0;

                if (!hasConfig) {
                    cleaned.reschedule = false;
                }
            }

            return cleaned;
        }

    },
    components: {
        TextToggle,
        MainLoader
    },
};
</script>
